import React from 'react'
import { Box } from '@mui/material'

import { dsColorNew } from '@palette'
import { cellBg } from './DistanceCell'


const swatch = (side, level) => <Box component="span" key={`${side}${level}`} sx={{ width: 18, height: 12, borderRadius: '3px', backgroundColor: cellBg({ side, level }), border: `1px solid ${dsColorNew.grayBorder}` }}/>

/** The colour scale, always visible (CA 13); the units and how to open a cell on the right */
export default function DistanceLegend({ mode, code, perDay, compact }) {
	const item = { display: 'inline-flex', alignItems: 'center', gap: 0.75 }
	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mt: 1.5, fontSize: 12, color: dsColorNew.textMuted }}>
		{mode === 'market'
			? <Box component="span" sx={item}>Each cell is the market median and how it moved: ▼ down · ▲ up · within ±1% no colour</Box>
			: <>
				<Box component="span" sx={item}>▼ − you are cheaper than the market {[3, 2, 1].map(l => swatch('cheaper', l))}{[1, 2, 3].map(l => swatch('dearer', l))} ▲ + dearer</Box>
				<Box component="span">≈ within ±2%: in line</Box>
				<Box component="span" sx={item}><Box component="span" sx={{ width: 14, height: 12, borderRadius: '3px', boxShadow: `inset 0 0 0 2px ${dsColorNew.successText}` }}/> you are the cheapest</Box>
			</>}
		<Box component="span"><Box component="b" sx={{ color: dsColorNew.noteAmber }}>!</Box> few prices behind (under 5)</Box>
		{compact && <Box component="span">no you: no price of yours · &lt;2 comp.: fewer than 2 competitors</Box>}
		<Box sx={{ flex: 1 }}/>
		<Box component="span">Prices in {code}, {perDay ? 'per day of rental' : 'total for the rental'}{compact ? ' · € in the detail' : ''} · click a cell for details</Box>
	</Box>
}
